import {
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "features/Modal/styled";
import React, { ReactNode } from "react";
import ReactModal from "react-modal";
import { ReactComponent as SVGClose24 } from "../../assets/close24.svg";

function Modal({
  children,
  isOpen = true,
  closeModal,
  title,
  shouldCloseOnOverlayClick = true,
  shouldCloseOnEsc = true,
}: {
  children: ReactNode;
  isOpen?: boolean;
  closeModal: () => void;
  title?: string;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
}) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
      overlayElement={(props, contentElement) => (
        <ModalOverlay {...props} style={{}}>
          {contentElement}
        </ModalOverlay>
      )}
      contentElement={(props, contentChildren) => (
        <ModalContent {...props} style={{}}>
          <ModalCloseButton type="button" onClick={closeModal}>
            <SVGClose24 />
          </ModalCloseButton>
          {contentChildren}
        </ModalContent>
      )}
    >
      {title && <ModalHeader>{title}</ModalHeader>}
      <>{children}</>
    </ReactModal>
  );
}

export default Modal;
